import ShippingInformationForm from './ShippingInformationForm'

export default ShippingInformationForm
